export const taskTypeMeta = (task) => {
  if (task?.origin === 'corrective' || task?.metadata?.source === 'action' || task?.metadata?.actionId) {
    return {
      key: 'corrective',
      label: 'Corrective',
      color: '#be185d',
      bg: '#fce7f3',
      title: 'Created from a remedial to fix a problem that was found',
    }
  }
  if (task?.complianceObligation || task?.metadata?.programmeObligationId || task?.metadata?.programme_obligation_id) {
    return {
      key: 'obligation',
      label: 'Obligation',
      color: '#0e7490',
      bg: '#e6f7f9',
      title: 'Linked to a compliance obligation. Recurs on the obligation’s schedule',
    }
  }
  if (task?.recurrenceType === 'repeating') {
    return {
      key: 'recurring',
      label: 'Recurring',
      color: '#7c3aed',
      bg: '#ede9fe',
      title: 'A repeating task that recreates itself on a schedule',
    }
  }
  return {
    key: 'one_off',
    label: 'One-off',
    color: '#64748b',
    bg: '#eef2f6',
    title: 'A one-off task that happens once',
  }
}
